<script>
const BASE_CLASS = 'form-control input-sm'

export default {
  name: 'TextInput',
  props: {
    value: String,
    textOnly: Boolean,
    disabled: Boolean,
  },
  model: {
    event: 'change',
  },
  data: function () {
    return {
      cssClass: BASE_CLASS,
    }
  },
  methods: {
    pushValue: function ({ target: { value } }) {
      const isNotEmpty = value !== ''
      const isNotIncludeNumeric = !/\d/g.test(value)
      const rules = [isNotEmpty]
      // Add rules
      if (this.textOnly) rules.push(isNotIncludeNumeric)
      // Validate rules
      const isValid = rules.every((i) => i)
      // Set cosmetic
      this.cssClass = !isValid ? BASE_CLASS + ' bd-red' : BASE_CLASS
      // Push out value
      this.$emit('change', value)
    },
  },
}
</script>

<template>
  <input type="text" :class="cssClass" :disabled="disabled" :value="value" @change="pushValue" />
</template>
